/**
 * @author 季兰兰
 * @date 2022-01-24 16:18:39
 * @description 滑块验证码
 */
import React, {FunctionComponent, useMemo, useState} from "react";
import Right from "@para-ui/icons/Right";
// import Modal from "@para-ui/core/Modal";
// import Loading from "@para-ui/core/Loading";
import CheckCircleF from "@para-ui/icons/CheckCircleF";
import {checkVerifyImage, newVerifyImage} from "../services";
import {message} from "para-ui";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import Loading from "./Loading";

/** 组件参数说明 **/
interface Props {
    /** 回调验证结果出去 **/
    callback: Function;
    /** 用户名 **/
    username: string;

}

/** 验证码图片信息 **/
interface ImgProps {
    /** 宽 **/
    width: number;
    /** 高 **/
    height: number;
    /** 图片地址 **/
    value: string
}

const loadingImg = require('../img/loading.gif');
const safetyIcon = require('../img/safety.png');

/** 大图的样式的宽度 **/
const bigImgBoxWidth = 300;
/** 滑块可移动的最大距离 **/
const maxWidth = bigImgBoxWidth - 40;
/**初始是未定义  鼠标放下之后 记录数字  **/
let firstPageX: number | undefined = undefined;
/** 当前是不是在拖动状态 **/
let isMoveing: boolean = false;

const CodeValidate: FunctionComponent<Props> = (props) => {
    const {callback, username} = props;
    /** 当前验证状态 0 是还没有验证  1 是验证成功 **/
    const [validateStatus, setValidateStatus] = useState<number>(0);
    /** 小图片的初始的y坐标 **/
    const [yPosition, setYposition] = useState<number>(0);
    /** 拖动滑块的时候 小图片的x坐标 **/
    const [xPosition, setXposition] = useState<number>(0);
    /** 拖动停止 结束位置移动 **/
    const [stop, setStop] = useState<boolean>(false);
    /** 图片比例 **/
    const [scale, setScale] = useState<number>(1);
    /** 验证码弹框显示隐藏 **/
    const [open, setOpen] = useState<boolean>(false);
    /** 初始的y值 **/
    const [initialY, setInitialY] = useState<string>("");
    /** 加载的状态 **/
    const [loading, setLoading] = useState<boolean>(false);
    /** 大图大小信息 **/
    const [bigImg, setBigImg] = useState<ImgProps>({
        width: 0,
        height: 0,
        value: ""
    });
    /** 小图大小信息 **/
    const [smallImg, setSmallImg] = useState<ImgProps>({
        width: 0,
        height: 0,
        value: ""
    });

    /**
     * 鼠标抬起 或者 触碰抬起的事件
     */
    const onMouseUp = () => {
        if (!isMoveing) return;
        isMoveing = false;
        setStop(true);
        checkPosition();
        // 注销监听事件
        document.removeEventListener("touchmove", moveFn);
        document.removeEventListener("mousemove", moveFn);
        document.removeEventListener("mouseup", onMouseUp);
        document.removeEventListener("touchend", onMouseUp);
    };

    /**
     * 鼠标或者手指移动事件
     * @param ev 事件对象
     */
    const moveFn = (ev: any) => {
        if (stop || !firstPageX) return;
        ev.stopPropagation();
        let pageX: number;
        if (ev.touches && ev.touches[0]) {
            // 移动端
            pageX = ev.touches[0].pageX;
        } else {
            pageX = ev.pageX;
        }
        let moveW = pageX - firstPageX; // 鼠标移动的距离
        if (moveW < 0) moveW = 0;
        (moveW < maxWidth) && setXposition(moveW);
    };

    //
    /**
     * 鼠标或者手放下记录初始位置
     * @param ev 事件对象
     */
    const onMouseDown = (e: any) => {
        // 在这里注册监听事件 addEvetListen    在 mouseup的remove监听的事件
        e.persist();
        firstPageX = e.pageX || e.touches[0].clientX;
        isMoveing = true;
        document.addEventListener("touchmove", moveFn);
        document.addEventListener("mousemove", moveFn);
        document.addEventListener("mouseup", onMouseUp);
        document.addEventListener("touchend", onMouseUp);
    };

    /**
     * 接口校验位置是否正确
     */
    const checkPosition = async () => {
        // 开始校验之后 滑块回到原点 提示报错信息  不能关闭弹框
        let param = {
            y: initialY,
            x: Math.floor(xPosition * scale),
            userName: username
        };
        const {data, err} = await checkVerifyImage(param);
        console.log(data, err)
        handleClose();
        if (err) {
            callback();
            return;
        }
        const code = data?.data?.code;
        // 校验成功 关闭弹框
        if (code) {
            callback(code);
            setValidateStatus(1);

        } else {
            //ParaUIMessage.error(data?.msg);
            message.warning(data?.msg);
            callback();
        }
    };

    /**
     * 点击关闭图形验证码
     */
    const handleClose = () => {
        setOpen(false);
        setStop(false);
        setXposition(0);
        firstPageX = undefined;
    };

    /**
     * 初始化图片
     */
    const initImg = async () => {
        // 校验用户名
        // 请输入帐号
        if (!username) return message.warning("请输入帐号");
        setLoading(true);
        const {data, err} = await newVerifyImage(username);
        setLoading(false);
        if (err) return;
        const {sourceImage, newImage, y} = data.data;
        const base64: string = "data:image/png;base64,";
        setInitialY(y);
        // 拿到图片 拿到比例
        let scaleVal = 1;
        const imgBg = document.createElement("img");
        imgBg.setAttribute("src", base64 + sourceImage);
        imgBg.onload = () => {
            const a = imgBg.width;
            const b = imgBg.height;
            scaleVal = a / bigImgBoxWidth;
            setScale(scaleVal);
            // 设置图片值
            setBigImg({
                width: a / scaleVal,
                height: b / scaleVal,
                value: base64 + sourceImage
            });
            setYposition(y / scaleVal);
        };
        const imgBgSmall = document.createElement("img");
        imgBgSmall.setAttribute("src", base64 + newImage);
        imgBgSmall.onload = () => {
            const a = imgBgSmall.width;
            const b = imgBgSmall.height;
            // 设置图片值
            setSmallImg({
                width: a / scaleVal,
                height: b / scaleVal,
                value: base64 + newImage
            });
            setOpen(true);
        };
    };

    /** 计算出小图片的bottom值 **/
    const yPositionRender = useMemo(() => {
        // 大图高度 + 中间的间距 + 滑块高度  = 总高度
        // 总高度 - 小图的高度 - Y周坐标 = 图片底部距滑块底部的高度
        return ((bigImg.height + 15 + 40) - smallImg.height - Number(yPosition)) + "px";
    }, [yPosition, smallImg]);

    return (
        <div className="slider-captcha">
            {
                validateStatus === 0 ?
                    (
                        <div className="validate-btn-box" onClick={initImg}>
                            <img className="safety-icon"
                                 src={safetyIcon}
                                // 点击开始验证
                                 alt=""/> {"点击开始验证"}
                        </div>
                    ) : (
                        // 验证成功
                        <div className="validate-btn-box"><CheckCircleF/>{"验证成功"}</div>
                    )
            }
            {
                loading && <Loading/>
            }
            {/*<Modal*/}
            {/*    open={open}*/}
            {/*    // showActions={false}*/}
            {/*    size="sm"*/}
            {/*    className="slider-captcha-dialog"*/}
            {/*    // 请完成安全验证！*/}
            {/*    title={"请完成安全验证"}*/}
            {/*    onCancel={handleClose}*/}
            {/*>*/}
            {/*    <div className="code-validate-modal">*/}
            {/*        <div className="validate-btn-box  slider-box" style={{marginTop: bigImg.height + 20 + "px"}}>*/}
            {/*            <Right style={{left: xPosition + "px"}} className="slider-btn"*/}
            {/*                   onMouseDown={onMouseDown}*/}
            {/*                   onTouchStart={onMouseDown}*/}
            {/*                   onMouseUp={onMouseUp}*/}
            {/*                   onTouchEnd={onMouseUp}*/}
            {/*            />*/}
            {/*            <img className="big-img" src={bigImg.value} alt=""/>*/}
            {/*            <img className="small-img" src={smallImg.value}*/}
            {/*                 style={{*/}
            {/*                     bottom: yPositionRender,*/}
            {/*                     left: xPosition + "px",*/}
            {/*                     width: smallImg.width + "px",*/}
            {/*                     height: smallImg.height + "px"*/}
            {/*                 }}*/}
            {/*                 alt=""/>*/}
            {/*            {*/}
            {/*                stop && <div className="big-img loading-img"><img src={loadingImg}/></div>*/}
            {/*            }*/}
            {/*            <span className="progress" style={{width: xPosition + "px"}}/>*/}
            {/*            向右滑动填充拼图*/}
            {/*            {"向右滑动填充拼图"}*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</Modal>*/}
            <Dialog
                open={open}
                className="slider-captcha-dialog"
                onClose={handleClose}
            >
                <DialogTitle id="responsive-dialog-title">
                    <Typography variant="h6">请完成安全验证</Typography>
                    <IconButton aria-label="close" className='close-btn' onClick={handleClose}>
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>
                <div className="code-validate-modal">
                    <div className="validate-btn-box  slider-box" style={{marginTop: bigImg.height + 20 + "px"}}>
                        <Right style={{left: xPosition + "px"}} className="slider-btn"
                               onMouseDown={onMouseDown}
                               onTouchStart={onMouseDown}
                               onMouseUp={onMouseUp}
                               onTouchEnd={onMouseUp}
                        />
                        <img className="big-img" src={bigImg.value} alt=""/>
                        <img className="small-img" src={smallImg.value}
                             style={{
                                 bottom: yPositionRender,
                                 left: xPosition + "px",
                                 width: smallImg.width + "px",
                                 height: smallImg.height + "px"
                             }}
                             alt=""/>
                        {
                            stop && <div className="big-img loading-img"><img src={loadingImg}/></div>
                        }
                        <span className="progress" style={{width: xPosition + "px"}}/>
                        向右滑动填充拼图
                        {"向右滑动填充拼图"}
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default CodeValidate;
